import { MaintenanceTranslation } from '@/assets/locales/views/maintenance/maintenance.translation.en.ts';

export const maintenanceTranslation: MaintenanceTranslation = {
  message: 'Prowadzimy prace serwisowe w aplikacji. Niedługo wracamy.',
  title: 'Trwa maintenance',
};
